import React from 'react';
import './App.css';
import PrivacyPolicy from './components/PrivacyPolicy';

function App() {
  return (
    <div className="App">
      <PrivacyPolicy />
    </div>
  );
}

export default App;
